// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../_css-loader@6.11.0@css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../_css-loader@6.11.0@css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".van-list__error-text,.van-list__finished-text,.van-list__loading{color:#969799;font-size:3.733333vw;line-height:13.333333vw;text-align:center}.van-list__placeholder{height:0;pointer-events:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
